module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aside-menu-wrapper"
  }, [_c('div', {
    class: ['aside-menu', _vm.showMenu ? 'show' : ''],
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.close($event)
      },
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "aside-menu-menus"
  }, _vm._l((_vm.realMenus), function(item, index) {
    return _c('div', {
      staticClass: "menus-modules"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t(("menus.backend." + (item.code)))))]), _vm._v(" "), _c('ul', {
      staticClass: "modules"
    }, _vm._l((item.backendModuleList), function(module) {
      return _c('li', {
        staticClass: "module"
      }, [_c('a', {
        key: module.code,
        attrs: {
          "href": module.path,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.$t(("menus.backendModule." + (module.code)))))])])
    }))])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4bdd810"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/asideMenu.vue
// module id = 270
// module chunks = 5